import { render, staticRenderFns } from "./WechatConfigList.vue?vue&type=template&id=aba30084&scoped=true"
import script from "./WechatConfigList.vue?vue&type=script&lang=js"
export * from "./WechatConfigList.vue?vue&type=script&lang=js"
import style0 from "./WechatConfigList.vue?vue&type=style&index=0&id=aba30084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba30084",
  null
  
)

export default component.exports